import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ settings }) {
  return (
    <footer className="relative border-t border-white/10 bg-sfc-night px-5 py-14 lg:px-10">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src="/soulfoodcity-logo.webp" alt="Soul Food City Drinks" className="h-12 w-12 rounded-full object-cover" />
            <span className="font-display text-lg text-white">SOUL FOOD CITY <span className="text-sfc-orange">DRINKS</span></span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-white/60">
            Premium exotische drankjes voor de horeca. Kleur, energie en tropische smaak — uitsluitend voor zakelijke klanten.
          </p>
        </div>
        <div>
          <h4 className="font-display text-sm uppercase tracking-widest text-sfc-yellow">Contact</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li>E-mail: <a className="hover:text-white" href={`mailto:${settings?.sales_email || "sales@soulfoodcity.nl"}`}>{settings?.sales_email || "sales@soulfoodcity.nl"}</a></li>
            <li>WhatsApp: <a className="hover:text-white" href={`https://wa.me/${(settings?.whatsapp_number || "+31614908691").replace(/[^0-9]/g, "")}`}>{settings?.whatsapp_number || "+31614908691"}</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-sm uppercase tracking-widest text-sfc-yellow">Juridisch</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li><Link data-testid="footer-terms" className="hover:text-white" to="/voorwaarden">Algemene voorwaarden</Link></li>
            <li><Link data-testid="footer-privacy" className="hover:text-white" to="/privacy">Privacybeleid</Link></li>
            <li><Link data-testid="footer-admin" className="hover:text-white" to="/admin/login">Beheerdersportaal</Link></li>
          </ul>
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-7xl border-t border-white/10 pt-6 text-xs text-white/40">
        © {new Date().getFullYear()} Soul Food City Drinks. Alle rechten voorbehouden. Uitsluitend zakelijke verkoop.
      </div>
    </footer>
  );
}
